import { filterHeadlinesByDepth, getHeadlines, normalizeHeadings, parseMaxDepth } from './headings';
import { addSelectEventListener, cleanupTocInstance, setupScrollHighlighting } from './highlighting';
import { DOMSTRING, mobileClass } from './init';
import { buildDesktopToc, buildMobileToc, clearToc } from './toc-renderer';

const buildToc = (headlineIndex, tocElement) => {
	cleanupTocInstance(tocElement);

	const isMobile = tocElement.classList.contains(mobileClass);
	const maxDepth = parseMaxDepth(tocElement);
	const headlines = getHeadlines(headlineIndex);

	if (headlines.length === 0) {
		clearToc(tocElement, isMobile);
		return;
	}

	const headingData = normalizeHeadings(headlines);
	const filteredHeadlines = filterHeadlinesByDepth(headingData, maxDepth);

	if (filteredHeadlines.length === 0) {
		clearToc(tocElement, isMobile);
		return;
	}

	if (isMobile) {
		buildMobileToc(filteredHeadlines, tocElement);
	} else {
		buildDesktopToc(filteredHeadlines, tocElement);
	}

	addSelectEventListener();
	setupScrollHighlighting(tocElement);
};

export const initTableOfContents = (toc) => {
	if (!toc) {
		console.warn('Table of Contents: TOC element not found');
		return;
	}

	const contentElement = document.querySelector(DOMSTRING.content);
	if (!contentElement) {
		console.warn('Table of Contents: Content element not found. Using document body as fallback.');
	}

	const headlineIndex = contentElement || document.body;
	buildToc(headlineIndex, toc);
};
